<template>
  <div class="sp-template">
    <div class="h-title">{{title}}</div>
    <el-card class="box-card">
      <el-form :model="form" size="small">
        <el-row>
          <el-col :span="10">
            <el-form-item label="产品SKU" :label-width="formLabelWidth">
              <el-input v-model.lazy="form.test" placeholder="产品SKU"></el-input>
            </el-form-item>
            <el-form-item label="中文品名" :label-width="formLabelWidth">
              <el-input v-model.lazy="form.test" placeholder="中文品名"></el-input>
            </el-form-item>
            <el-form-item label="英文品名" :label-width="formLabelWidth">
              <el-input v-model.lazy="form.test" placeholder="英文品名"></el-input>
            </el-form-item>
            <el-form-item label="净重(kg)" :label-width="formLabelWidth">
              <el-input v-model.lazy="form.test" placeholder="净重(kg)"></el-input>
            </el-form-item>
            <el-form-item label="申报价值" :label-width="formLabelWidth">
              <el-row>
                <el-col :span="9">
                  <el-select v-model.lazy="form.select" class="width100">
                    <el-option v-for="(d, i) in customer" :key="i" :label="d.name" :value="d.value"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="15" class="width100">
                  <el-input v-model.lazy="form.test" placeholder="申报价值"></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="商品图片" :label-width="formLabelWidth">
              <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label-width="formLabelWidth">
          <el-button size="small" @click="back">返 回</el-button>
          <el-button size="small" v-if="title == '新建商品'" type="warning">继续添加</el-button>
          <el-button size="small" type="primary">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { test: "", select: "001" },
      customer: [{ name: "666", value: "001" }, { name: "777", value: "002" }],
      formLabelWidth: "120px",
      dialogImageUrl: "", //上传图片
      dialogVisible: false
    };
  },
  components: {},
  created() {
    this.$route.query.data && (this.form.test = this.$route.query.data.test);
  },
  computed: {
    title() {
      let title = "";
      title = this.$route.query.data ? "编辑商品" : "新建商品";
      return title;
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    //上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/goods/newgoods.vue